/**
 * Hook : observe la largeur d'un container via ResizeObserver et retourne
 * (ref, width). Bornée à `MIN_CONTAINER_WIDTH_PX`, default = largeur
 * approximative d'un widget dashboard 2-col en attendant la 1ère mesure.
 */

import { useEffect, useRef, useState } from "react";

import { DEFAULT_CONTAINER_WIDTH_PX, MIN_CONTAINER_WIDTH_PX } from "./constants.js";

export function useResizeWidth<T extends HTMLElement>(): [React.RefObject<T | null>, number] {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState<number>(DEFAULT_CONTAINER_WIDTH_PX);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width ?? DEFAULT_CONTAINER_WIDTH_PX;
      setWidth(Math.max(MIN_CONTAINER_WIDTH_PX, Math.round(w)));
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return [ref, width];
}
